import {getStatusLabel, getStatusColor} from '@@/core/libraries/adminFunctions'
export default {
    props:{
        status: String,
        reserved:{
          default:0,
          type:Number
        }
    },
    methods:{
      getStatusLabel,getStatusColor
    }
}
